import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import BannerAds from "./BannerAds";
import "./LovePage.css";

const BASE_URL =
  window.location.hostname === "localhost"
 ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

function LovePage() {
  const navigate = useNavigate();

  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("love");
  const [stats, setStats] = useState({ loveCount: 0, friendCount: 0 });
  const [bubbles, setBubbles] = useState([]);
  const [petals, setPetals] = useState([]); 
  const [sparkles, setSparkles] = useState([]);
  const [floatingHearts, setFloatingHearts] = useState([]);
  const [showWaterfall, setShowWaterfall] = useState(false);
  const autoPetalTimer = useRef(null);
  const isMobile = useRef(window.innerWidth < 768);

  useEffect(() => {
    loadStats();
    return () => clearInterval(autoPetalTimer.current);
  }, []);

  const loadStats = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/love/stats`);
      setStats(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // OPTIMIZED: count taggincham
  const createBubbles = useCallback((count) => {
    const bubbleCount = isMobile.current? Math.floor(count/2) : count;
    const newBubbles = Array.from({ length: bubbleCount }, (_, i) => ({
      id: Date.now() + i,
      left: Math.random() * 100,
      size: Math.random() * 12 + 8,
      delay: Math.random() * 2,
      emoji: mode === "love" ? "❤️" : "🤝"
    }));
    setBubbles(prev => [...prev, ...newBubbles]);
    setTimeout(() => {
      setBubbles(prev => prev.filter(b => !newBubbles.find(nb => nb.id === b.id)));
    }, 8000);
  }, [mode]);

  // OPTIMIZED: 20 -> 8 petals
  const createPetals = useCallback(() => {
    const petalCount = isMobile.current? 5 : 8;
    const newPetals = Array.from({ length: petalCount }, (_, i) => ({
      id: Date.now() + i + Math.random(),
      left: Math.random() * 100,
      size: Math.random() * 10 + 10,
      delay: Math.random() * 2,
      duration: Math.random() * 3 + 5,
      rotate: Math.random() * 360
    }));
    setPetals(newPetals);
    setTimeout(() => setPetals([]), 8000); 
  }, []);

  // OPTIMIZED: 15 -> 6 sparkles
  const createSparkles = useCallback(() => {
    const sparkleCount = isMobile.current? 3 : 6;
    const newSparkles = Array.from({ length: sparkleCount }, (_, i) => ({
      id: Date.now() + i + Math.random(),
      top: Math.random() * 100,
      left: Math.random() * 100,
      size: Math.random() * 3 + 2,
      delay: Math.random() * 1
    }));
    setSparkles(newSparkles);
    setTimeout(() => setSparkles([]), 1500);
  }, []);

  // OPTIMIZED: 8 -> 3 hearts
  const createFloatingHearts = useCallback(() => {
    const heartCount = isMobile.current? 2 : 3;
    const newHearts = Array.from({ length: heartCount }, (_, i) => ({
      id: Date.now() + i + Math.random(),
      left: Math.random() * 100,
      size: Math.random() * 16 + 12,
      delay: Math.random() * 1.5,
      duration: Math.random() * 3 + 6
    }));
    setFloatingHearts(newHearts);
    setTimeout(() => setFloatingHearts([]), 9000);
  }, []);

  const startLove = async (type) => {
    if (!name1.trim() ||!name2.trim()) {
      return alert("Please enter both names.");
    }
    if (name1.length > 25 || name2.length > 25) {
      return alert("Maximum 25 characters allowed.");
    }
    if (message.length > 50) {
      return alert("Maximum 50 characters.");
    }

    setMode(type);
    createBubbles(12); // 20 -> 12
    createSparkles();
    createFloatingHearts();

    try {
      await axios.post(`${BASE_URL}/api/love`, {
        name1: name1.trim(),
        name2: name2.trim(),
        message: message.trim(),
        type,
      });

      loadStats();
      setShow(true);
      setShowWaterfall(true); 
      
      // OPTIMIZED: 3s -> 6s, heavy animations taggincham
      autoPetalTimer.current = setInterval(() => {
        createPetals();
        createSparkles();
      }, 6000);

    } catch (err) {
      console.log(err);
      alert("Server Error");
    }
  };

  const handleGoBack = () => {
    clearInterval(autoPetalTimer.current);
    setShow(false);
    setShowWaterfall(false);
    setName1("");
    setName2("");
    setMessage("");
    setPetals([]);
    setSparkles([]);
    setFloatingHearts([]);
  }

  const contactForLeaderboard = () => {
    window.open(
      "https://wa.me/918095996203?text=Hi%20Team,%20I%20want%20to%20add%20my%20name%20to%20the%20Leaderboard.",
      "_blank"
    );
  };

  if (show) {
    return (
      <>
        <div className="lp-bg-overlay"></div>
        {/* VIDEO REMOVED - image use chey for performance */}
        <div className="lp-bg-image" style={{backgroundImage: `url(/srikrishna.jpg)`}}></div>
        
        {showWaterfall && (
          <div className="lp-waterfall">
            {[...Array(isMobile.current? 6 : 10)].map((_, i) => <div key={i} className="lp-water-drop"></div>)}
          </div>
        )}

        <div className="lp-bubbles-layer">
          {bubbles.map(b => (
            <span key={b.id} className="lp-bubble" style={{left: `${b.left}%`, fontSize: `${b.size}px`, animationDelay: `${b.delay}s`}}>
              {b.emoji}
            </span>
          ))}
        </div>

        <div className="lp-petals-layer">
          {petals.map(p => (
            <span key={p.id} className="lp-petal" style={{left: `${p.left}%`, fontSize: `${p.size}px`, animationDelay: `${p.delay}s`, animationDuration: `${p.duration}s`, transform: `rotate(${p.rotate}deg)`}}>🌹</span>
          ))}
        </div>

        <div className="lp-sparkles-layer">
          {sparkles.map(s => (
            <span key={s.id} className="lp-sparkle" style={{top: `${s.top}%`, left: `${s.left}%`, width: `${s.size}px`, height: `${s.size}px`, animationDelay: `${s.delay}s`}}></span>
          ))}
        </div>

        <div className="lp-floating-hearts">
          {floatingHearts.map(h => (
            <span key={h.id} className="lp-float-heart" style={{left: `${h.left}%`, fontSize: `${h.size}px`, animationDelay: `${h.delay}s`, animationDuration: `${h.duration}s`}}>💖</span>
          ))}
        </div>

        <Navbar />

        <div className={`love-result ${mode === "love"? "result-love" : "result-friend"}`}>
          <h1 className="result-names">
            {mode === "love" ? `${name1} ❤️ ${name2}` : `${name1} 🤝 ${name2}`}
          </h1>
          {message && <p className="result-msg">💌 "{message}"</p>}
          <button className="btn-back" onClick={handleGoBack}>
            ← Create Again
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="lp-bg-overlay"></div>
      <div className="lp-bg-image" style={{backgroundImage: `url(/radhakrishna.jpg)`}}></div>

      <div className="lp-bubbles-layer">
        {bubbles.map(b => (
          <span key={b.id} className="lp-bubble" style={{left: `${b.left}%`, fontSize: `${b.size}px`, animationDelay: `${b.delay}s`}}>
            {b.emoji}
          </span>
        ))}
      </div>

      <Navbar />

      <div className="love-page">
        <BannerAds />
        <div className="lp-header">
          <h1>Love & Friendship <span>Creator</span></h1>
          <p>Express what words alone cannot 💗</p>
        </div>

       

        <div className="form-card">
          <input type="text" placeholder="Your Name" value={name1} maxLength={25} onChange={(e) => setName1(e.target.value)} />
          <span className="char-count">{name1.length}/25</span>

          <input type="text" placeholder="Partner / Friend Name" value={name2} maxLength={25} onChange={(e) => setName2(e.target.value)} />
          <span className="char-count">{name2.length}/25</span>

          <textarea placeholder="Message (Optional)" maxLength={50} value={message} onChange={(e) => setMessage(e.target.value)} rows={3} />
          <span className="char-count">{message.length}/50</span>

          <div className="btn-group">
            <button className="btn-love" onClick={() => startLove("love")}>❤️ Create Love</button>
            <button className="btn-friend" onClick={() => startLove("friend")}>🤝 Create Friendship</button>
          </div>

          <button className="btn-contact" onClick={contactForLeaderboard}>📲 Contact Team for Leaderboard</button>
          <button className="btn-board" onClick={() => navigate("/lovelist")}>⭐ View Leaderboard</button>
        </div>
      </div>
    </>
  );
}

export default LovePage;